export interface TaskDetailNavState {
  readonly fromPath: string;
  readonly siblingTaskIds: readonly string[];
}

export const DEFAULT_TASK_DETAIL_FROM_PATH = '/tasks';

export function buildTaskDetailNavState(
  fromPath: string,
  tasks: readonly { id: string }[],
): TaskDetailNavState {
  return {
    fromPath,
    siblingTaskIds: tasks.map((task) => task.id),
  };
}

export function parseTaskDetailNavState(state: unknown): TaskDetailNavState {
  if (!state || typeof state !== 'object') {
    return { fromPath: DEFAULT_TASK_DETAIL_FROM_PATH, siblingTaskIds: [] };
  }
  const fromPathValue = 'fromPath' in state ? state.fromPath : undefined;
  const siblingValue = 'siblingTaskIds' in state ? state.siblingTaskIds : undefined;
  const fromPath =
    typeof fromPathValue === 'string' && fromPathValue.startsWith('/')
      ? fromPathValue
      : DEFAULT_TASK_DETAIL_FROM_PATH;
  const siblingTaskIds = Array.isArray(siblingValue)
    ? siblingValue.filter((id: unknown): id is string => typeof id === 'string')
    : [];
  return { fromPath, siblingTaskIds };
}
